/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RespiratoryMonitoringEditorAliases {
  ACTION_DELETE_RESPIRATORY_MONITORING = 'action-delete-respiratory-monitoring',
  AUTOCOMPLETE_ACCESSORY = 'autocomplete-accessory',
  AUTOCOMPLETE_BREATH = 'autocomplete-breath',
  AUTOCOMPLETE_EQUIPMENT = 'autocomplete-equipment',
  AUTOCOMPLETE_MODALITY = 'autocomplete-modality',
  AUTOCOMPLETE_MUSCULATURE = 'autocomplete-musculature',
  AUTOCOMPLETE_STANDARD = 'autocomplete-standard',
  FETCH_ACCESSORY = 'fetch-accessory',
  FETCH_BREATH = 'fetch-breath',
  FETCH_EQUIPMENT = 'fetch-equipment',
  FETCH_MODALITY = 'fetch-modality',
  FETCH_MUSCULATURE = 'fetch-musculature',
  FETCH_STANDARD = 'fetch-standard',
  FIELD_ACCESSORY = 'field-accessory',
  FIELD_AMP = 'field-amp',
  FIELD_BREATH = 'field-breath',
  FIELD_EQUIPMENT = 'field-equipment',
  FIELD_FIO = 'field-fio',
  FIELD_FLUXO = 'field-fluxo',
  FIELD_FREQ = 'field-freq',
  FIELD_INSP = 'field-insp',
  FIELD_MODALITY = 'field-modality',
  FIELD_MUSCULATURE = 'field-musculature',
  FIELD_NITRIC = 'field-nitric',
  FIELD_OXIDE = 'field-oxide',
  FIELD_OXYGEN = 'field-oxygen',
  FIELD_PEEP = 'field-peep',
  FIELD_PIP = 'field-pip',
  FIELD_PMVA = 'field-pmva',
  FIELD_RECORD_DATE = 'field-record-date',
  FIELD_SAT = 'field-sat',
  FIELD_STANDARD = 'field-standard',
  FIELD_VENT = 'field-vent',
  GLOBAL_ACTIONS = 'global-actions',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_AMP = 'input-amp',
  INPUT_DATETIME = 'input-datetime',
  INPUT_FIO = 'input-fio',
  INPUT_FLUXO = 'input-fluxo',
  INPUT_FREQ = 'input-freq',
  INPUT_INSP = 'input-insp',
  INPUT_NITRIC = 'input-nitric',
  INPUT_OXIDE = 'input-oxide',
  INPUT_OXYGEN = 'input-oxygen',
  INPUT_PEEP = 'input-peep',
  INPUT_PIP = 'input-pip',
  INPUT_PMVA = 'input-pmva',
  INPUT_SAT = 'input-sat',
  INPUT_VENT = 'input-vent',
  MAPPER_ACCESSORY = 'mapper-accessory',
  MAPPER_BREATH = 'mapper-breath',
  MAPPER_EQUIPMENT = 'mapper-equipment',
  MAPPER_MODALITY = 'mapper-modality',
  MAPPER_MUSCULATURE = 'mapper-musculature',
  MAPPER_STANDARD = 'mapper-standard',
  RELEASE_BUTTON = 'release-button',
  RESPIRATORY_MONITORING_EDITOR_CONTEXTUAL_BAR = 'respiratory-monitoring-editor-contextual-bar',
  RESPIRATORY_MONITORING_EDITOR_FORM = 'respiratory-monitoring-editor-form',
  RESPIRATORY_MONITORING_LAYOUT = 'respiratory-monitoring-layout',
  TEXT_ACCESSORY = 'text-accessory',
  TEXT_BREATH = 'text-breath',
  TEXT_EQUIPMENT = 'text-equipment',
  TEXT_MODALITY = 'text-modality',
  TEXT_MUSCULATURE = 'text-musculature',
  TEXT_STANDARD = 'text-standard',
}
export { RespiratoryMonitoringEditorAliases };
